import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';

export default {
  baseStyle: (props: StyleFunctionProps) => ({
    borderRadius: 'full',
    transition: 'all 0.2s',
    bg: mode(`blackAlpha.100`, `whiteAlpha.100`)(props),
    _disabled: {
      opacity: 0.4,
      cursor: 'not-allowed',
      boxShadow: 'none',
    },
    _hover: { bg: mode(`blackAlpha.200`, `whiteAlpha.200`)(props) },
    _active: { bg: mode(`blackAlpha.300`, `whiteAlpha.300`)(props) },
    _focus: {
      boxShadow: 'none',
    },
  }),
  defaultProps: {
    size: 'md',
    isRounded: true,
  },
};
